import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "One of the most collaborative and forward-thinking product managers I've worked with. He brings clarity, creativity, and calm to every project.",
    name: "Chioma N.",
    role: "UX Designer",
    avatar: "https://images.unsplash.com/photo-1628017975063-17b19666cc6a?w=200",
  },
  {
    quote:
      "Working with Anayo completely changed how we approached product development. He doesn't just manage a process — he builds confidence across the team.",
    name: "James T.",
    role: "CEO, HealthTech Company",
    avatar: "https://images.unsplash.com/photo-1582005450386-52b25f82d9bb?w=200",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="bg-zinc-950 text-white py-24 sm:py-32 grain"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14 sm:mb-20"
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter">
            What Clients Say
          </h2>
          <p className="mt-4 text-zinc-400">
            Hear what past and retainer clients say about me.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i}`}
              className="relative"
            >
              {/* Bubble */}
              <div className="relative rounded-3xl bg-zinc-900 border border-white/10 p-8 sm:p-10 shadow-[0_20px_50px_-20px_rgba(147,51,234,0.25)]">
                <span className="absolute -top-4 left-8 font-display text-6xl text-brand-500/60 leading-none select-none">
                  &ldquo;
                </span>
                <p className="text-lg sm:text-xl leading-relaxed text-zinc-100">
                  {t.quote}
                </p>
                {/* Tail */}
                <div className="absolute -bottom-3 left-12 h-6 w-6 rotate-45 bg-zinc-900 border-r border-b border-white/10"></div>
              </div>
              {/* Avatar + meta */}
              <div className="mt-7 ml-12 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="h-11 w-11 rounded-full object-cover ring-2 ring-brand-500/40"
                />
                <div>
                  <p className="text-sm font-medium text-white">{t.name}</p>
                  <p className="text-xs text-zinc-400">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
